<template>
    <themed-modal
        name="edit-proposal-expense"
        title="Edit Expense"
        size="md"
        :show-footer="true">
        
        <themed-form
            v-if="selectedProposalExpense"
            :fields="formFields"
            v-model="selectedProposalExpense"
            :errors="errors"
            layout="grid"
            :columns="3"
            :loading="loading">
            
            <template #submit>
                <!-- Footer buttons handled in modal footer slot -->
            </template>
        </themed-form>

        <template #footer>
            <themed-button variant="secondary" @click="$modal.hide('edit-proposal-expense')">
                Close
            </themed-button>
            <themed-button variant="default" @click="saveExpense" :disabled="loading">
                <span v-if="loading">Saving...</span>
                <span v-else>Save Expense</span>
            </themed-button>
        </template>
    </themed-modal>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import ThemedModal from '../ThemedModal.vue';
    import ThemedForm from '../form/ThemedForm.vue';
    
    export default {
        name: 'EditProposalExpenseV1',

        components: {
            ThemedModal,
            ThemedForm
        },

        data() {
            return { 
                expenseTypes: {},
                loading: false
            }
        },

        mounted() {
            axios.get('/api/expense-types').then((response) => {
                this.expenseTypes = response.data;
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: 'Error',
                    text: 'Error pulling Expense Types, please try again later'
                });
            });
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['selectedProposal']),
            ...mapGetters(['selectedProposalExpense']),

            errors() {
                return this.proposals.errors;
            },

            expenseTypeOptions() {
                return [
                    { value: '', label: 'Select type' },
                    ...Object.values(this.expenseTypes).map(type => ({
                        value: type.id,
                        label: type.name
                    }))
                ];
            },

            baseNetOptions() {
                return [
                    { value: '', label: 'Select option' },
                    { value: 'Base', label: 'Base' },
                    { value: 'Net', label: 'Net' },
                    { value: 'Included', label: 'Included' }
                ];
            },

            formFields() {
                return [
                    {
                        name: 'type_id',
                        label: 'Type',
                        type: 'select',
                        required: true,
                        options: this.expenseTypeOptions,
                        placeholder: 'Select type'
                    },
                    {
                        name: 'amount_in_dollars',
                        label: 'Amount PSF',
                        type: 'currency',
                        required: true,
                        componentProps: {
                            size: 11,
                            isDecimal: true
                        }
                    },
                    {
                        name: 'base_net_included',
                        label: 'Base or Net',
                        type: 'select',
                        required: true,
                        options: this.baseNetOptions,
                        placeholder: 'Select option'
                    }
                ];
            }
        },

        methods: {
            async saveExpense() {
                this.loading = true;

                await this.$store.dispatch('saveExpense').then(() => {
                    this.loading = false;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: "Expense Saved"
                    });

                    this.$emit('save-proposal');

                    this.$forceUpdate();

                    this.$modal.hide('edit-proposal-expense');
                });
            }
        }
    }
</script>
